import routerWithSidebar from "./routerWithSidebar";
import { PATH_PERMISSION, PATH_PERMISSION_NO } from "@/constants/URL";


export default {
  path: PATH_PERMISSION,
  component: () =>
    import(/* webpackChunkName: "SidebarLayout" */ "@/layout/SidebarLayout/index.vue"),
  children: [
    {
      path: PATH_PERMISSION,
      name: "permission",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/permission/index.vue")
      ),
      children: [
        {
          path: PATH_PERMISSION_NO,
          name: "PERMISSION_NO",
          components: routerWithSidebar(() =>
            import("@/views/permission/no.vue")
          )
        }
      ]
    }
  ]
};
